export const onboarding = {
  welcome_title: "Welcome to PAX!",
  welcome_body:
    "Power Asset Exchange enables utilities and energy producers to buy, sell, and redeploy gas turbine components.",

  org_intake_subheading:
    "To get started, please tell us about your organization",

  company_name_field: {
    label: "Company name",
    placeholder: "Acme Utilities",
  },

  intent_section_title: "How do you intend to use PAX?",

  intent_sell: "I want to sell parts",
  intent_buy: "I want to buy parts",

  continue: "Continue",

  ready_header: "Ready to list or browse the parts?",

  card_sell_title: "I want to sell parts",
  card_sell_subtitle: "Turn parts into repair credits",
  card_sell_cta: "Sell a Part",

  card_buy_title: "I want to buy parts",
  card_buy_subtitle: "Search inventory and buy components",
  card_buy_cta: "Browse Marketplace",

  how_pax_works_title: "How Pax Works",
  how_pax_step_1: "List or acquire parts",
  how_pax_step_2: "Funds held in trust",
  how_pax_step_3: "Repair credits issued",

  validation_company_required: "Enter your company name",
  validation_intent_required:
    "Select at least one way you plan to use PAX",

  save_error: "Could not save your organization profile. Please try again.",
};
